<template>
  <div id="app" :style="objectStyle">
    <Main/>
  </div>
</template>

<script>
import Main from '@/components/Main.vue'
export default {
  name: 'app',
  components: {
    Main
  },
  data () {
    return {
      objectStyle: {
        height: '100vh'
      }
    }
  },
  methods: {
    updateStyle () {
      this.objectStyle = {
        height: `${window.innerHeight}px`
      }
    }
  },
  mounted () {
    this.updateStyle()
    window.addEventListener('resize', this.updateStyle)
  }
}
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;700;900&display=swap');
  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  body {
    font-family: 'Lato', sans-serif !important;
    overflow: hidden;
  }
  #app {
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    overflow-x: hidden;
  }
</style>
